<p [innerHTML]="alertText"></p>
